export enum SaveAreaIconOptions {
  loading = 'area-saved-spinner',
  saved = 'area-saved-icon',
  error = `red-status`
}
export namespace OwlImageViewModel {
  export const getIconFullPath = (file: string) => `./assets/icons/${file}.svg`
}
